const MODULE_URL = 'sessions';
export default {
  ACTIVITY_URL: MODULE_URL + '/activity',

  WIZARD_PENDING: 'wizard_pending',
};
